<template>
  <div
    class="
      align-items-center
      d-flex
      flex-column
      justify-content-center
      text-center
      nodata-sub-national
    "

  >
    <h5>No Sub-National Level Data</h5>
    <p>
      There is no sub-national data available for the indicator, data source and
      period you have selected. Try selecting another data source or period.
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.nodata-sub-national {
  background: #ffffff;
  border: 1px solid #d6d6d6;
  border-radius: 6px;
  padding: 16px 20px;

  h5 {
    color: #232323;
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 6px;
  }

  p {
    color: #656565;
    font-size: 13px;
    margin: 0;
  }
}
</style>
